import cx from 'classnames';
import { Trans } from 'react-i18next';
import { Typography } from './typography';
import { relativeDate } from '../libs/utils';
import { ComplexTooltip, TooltipPlacement } from './presentational/tooltip';
import { CSSProperties } from 'react';

export const DarkModeIconTooltip = ({
  shareRaidUntil,
  className,
  style,
  placement,
  showArrow
}: {
  shareRaidUntil: string;
  className?: string;
  style?: CSSProperties;
  placement?: TooltipPlacement;
  showArrow?: boolean;
}) => {
  return (
    <ComplexTooltip
      showArrow={showArrow}
      placement={placement}
      renderJustChildren
      tooltip={
        <div style={{ maxWidth: 200 }}>
          <Typography.Title size="small" strong>
            <Trans i18nKey="guilds:dark-mode.guild-in-dark-mode">
              <i className="dark-mode-icon" />
            </Trans>
          </Typography.Title>
          <Trans
            i18nKey="guilds:dark-mode.guild-in-dark-mode-description"
            values={{ duration: relativeDate(shareRaidUntil) }}
          >
            <i className="text-raiderio" />
          </Trans>
        </div>
      }
    >
      <i className={cx('dark-mode-icon', className)} style={style} />
    </ComplexTooltip>
  );
};
